"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var icon_1 = __importDefault(require("../icon"));
var Modal = function (props) {
    var _a = props.maskClosable, maskClosable = _a === void 0 ? false : _a, _b = props.showCloseIcon, showCloseIcon = _b === void 0 ? false : _b, _c = props.size, size = _c === void 0 ? 'small' : _c, icon = props.icon, _d = props.type, type = _d === void 0 ? '' : _d, _e = props.title, title = _e === void 0 ? '' : _e, content = props.content, btnCancelMsg = props.btnCancelMsg, btnOkMsg = props.btnOkMsg, onOk = props.onOk, onCancel = props.onCancel, onDidClose = props.onDidClose, className = props.className;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var refWrap = (0, react_1.useRef)(null);
    var sizeClassName = 'size-s';
    var iconSize = 30;
    var iconColor = '';
    var closeIconColor = '#000000';
    if (size === 'large' || type) {
        sizeClassName = 'size-l';
    }
    if (sizeClassName === 'size-l') {
        iconSize = 46;
    }
    if (type && type !== 'text') {
        iconColor = '#FFFFFF';
        closeIconColor = '#FFFFFF';
    }
    else {
        if (icon === 'check-circle') {
            iconColor = '#0ABF5B';
        }
        else if (icon === 'info-circle') {
            iconColor = '#F37E11';
        }
    }
    var onCurClose = function () {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        onDidClose === null || onDidClose === void 0 ? void 0 : onDidClose();
    };
    var maskClose = function () {
        maskClosable && (onDidClose === null || onDidClose === void 0 ? void 0 : onDidClose());
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(className, "".concat(classPrefix, "-modal"), sizeClassName), ref: refWrap },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-header', "header-".concat(sizeClassName), type) },
                react_1.default.createElement("strong", { className: (0, classnames_1.default)('modal-confirm-title', "title-".concat(type)) },
                    icon && react_1.default.createElement(icon_1.default, { name: icon, size: iconSize, color: iconColor, className: "title-icon" }),
                    title),
                showCloseIcon && (react_1.default.createElement("a", { className: "modal-header-close", title: "Closse", onClick: onCurClose },
                    react_1.default.createElement(icon_1.default, { name: "close", size: 16, color: closeIconColor, className: "close" })))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-body', "body-".concat(sizeClassName), {
                    'body-no-btn': !btnCancelMsg && !btnOkMsg,
                    'body-has-type': type && type !== 'text',
                }) },
                react_1.default.createElement("div", { className: "modal-confirm" },
                    react_1.default.createElement("div", { className: "modal-confirm-desc", dangerouslySetInnerHTML: { __html: content || '' } }))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-footer', "footer-".concat(sizeClassName), {
                    'footer-no-btn': !btnCancelMsg && !btnOkMsg,
                }) },
                btnCancelMsg && (react_1.default.createElement("a", { className: (0, classnames_1.default)('modal-footer-btn', 'modal-footer-btn-cancle', "btn-".concat(sizeClassName)), onClick: onCurClose }, btnCancelMsg)),
                btnOkMsg && (react_1.default.createElement("a", { className: (0, classnames_1.default)('modal-footer-btn', 'modal-footer-btn-sumbit', "btn-".concat(sizeClassName)), onClick: function () {
                        onOk === null || onOk === void 0 ? void 0 : onOk();
                        onDidClose === null || onDidClose === void 0 ? void 0 : onDidClose();
                    } }, btnOkMsg)))),
        react_1.default.createElement("div", { className: "c-modal-mask", onClick: maskClose })));
};
function alert(props) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(react_1.default.createElement(Modal, __assign({}, props, { onDidClose: function () {
            var unmountResult = ReactDOM.unmountComponentAtNode(div);
            if (unmountResult && div.parentNode) {
                div.parentNode.removeChild(div);
            }
        } })), div);
}
Modal.alert = alert;
Modal.displayName = 'Modal';
exports.default = Modal;
//# sourceMappingURL=Modal.js.map